import { useState } from "react";
import {
  Button,
  Checkbox,
  DialogProps,
  FormControlLabel,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import BasicModal from "../../components/modal/BasicModal";
import useWorkflows from "../../../hooks/useWorkflows";
import TableSkeleton from "../../components/skeleton/TableSkeleton";

interface Task {
  name: string;
  [key: string]: any;
}

interface Workflow {
  name: string;
  tasks: Task[];
  [key: string]: any;
}

interface Props extends DialogProps {
  onClose: () => void;
  workflows?: Workflow[];
  data: any;
  onAdd: (selectedIds: string[]) => void;
  previousSelectedTasks?: any;

  // setSelectedTaskIds: any;
  // selectedTaskIds: any;
}

const SelectWorkflowModal = ({
  onClose,
  //   workflows = [],
  data,
  onAdd,
  previousSelectedTasks,
  // setSelectedTaskIds,
  // selectedTaskIds,
  ...props
}: Props) => {
  const { workflows, isLoadingWorkflows } = useWorkflows();
  const [selectedTaskIds, setSelectedTaskIds] = useState<string[]>(
    previousSelectedTasks || []
  );

  // const handleToggleTask = (taskId: string) => {
  //   setSelectedTaskIds((prev: any) =>
  //     prev.includes(taskId)
  //       ? prev.filter((id: any) => id !== taskId)
  //       : [...prev, taskId]
  //   );
  // };

  const handleToggleTask = (task: any) => {
    setSelectedTaskIds((prev: any[]) => {
      const exists = prev.some((t) => t._id === task._id);
      if (exists) {
        return prev.filter((t) => t._id !== task._id); // Remove
      } else {
        return [...prev, task]; // Add
      }
    });
  };

  //   if (isLoadingWorkflows) {
  //     return <TableSkeleton />;
  //   }

  return (
    <BasicModal
      onClose={onClose}
      title="Select Tasks That You Have Already Completed"
      height="calc(100vh - 230px)"
      size="sm"
      content={
        <Grid container spacing={3}>
          {isLoadingWorkflows ? (
            // <Grid item xs={12}>
            //   <Typography>No workflows available.</Typography>
            // </Grid>
            <TableSkeleton />
          ) : (
            workflows?.map((workflow: any) => (
              <Grid item xs={12} key={workflow.name}>
                <Typography variant="h6" gutterBottom>
                  {workflow.name}
                </Typography>
                <Box pl={2}>
                  {workflow?.tasks?.map((task: any) => (
                    <Box key={task.task} sx={{ display: "block", mb: 1 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedTaskIds?.some(
                              (t: any) => t?._id === task._id
                            )}
                            onChange={() => handleToggleTask(task)}
                          />
                        }
                        label={
                          <Typography
                            variant="body2"
                            sx={{ whiteSpace: "normal" }}
                          >
                            {task.task}
                          </Typography>
                        }
                      />
                    </Box>
                  ))}
                </Box>
              </Grid>
            ))
          )}
        </Grid>
      }
      actions={
        <Grid item xs={12} textAlign="right">
          <Button
            color="error"
            variant="outlined"
            sx={{ mr: 4, textTransform: "capitalize" }}
            onClick={() => {
              // onAdd([]);
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            disabled={selectedTaskIds.length === 0}
            sx={{ textTransform: "capitalize" }}
            onClick={() => {
              // const selectedTasks = workflows
              //   .flatMap((workflow: any) => workflow.tasks)
              //   .filter((task: any) => selectedTaskIds.includes(task._id));
              // console.log("Selected Tasks:", selectedTasks);
              onAdd(selectedTaskIds); // Pass data to parent
              onClose();
            }}
          >
            Save
          </Button>
        </Grid>
      }
      {...props}
    />
  );
};

export default SelectWorkflowModal;
